import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { CellFunction, DirectCell } from '../../cells';

import { IEpxFallRisk } from '../../../../../libs/apps/epxfallrisk';

const EpxFallRiskTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxFallRisk>[] = [
    {
      Header: 'Falls',
      id: 'falls',
      Cell: ResponseGuard(DirectCell('falls') as CellFunction<IEpxFallRisk>)
    },
    {
      Header: 'Stumbles/Trips',
      id: 'stumbles',
      Cell: ResponseGuard(DirectCell('stumbles') as CellFunction<IEpxFallRisk>)
    }
  ];
  return (
    <SessionTable<IEpxFallRisk>
      url="/epxfallrisk/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxFallRiskTable;
